import * as React from "react";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { message } from "antd";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { ProjectDocumentsTable } from "Components/General/AddFilesInput/ProjectDocumentsTable";
import { ProjectFilesSearch } from "./ProjectFilesSearch";

interface AttachProjectFilesProps extends WithTranslation, ModalComponentProps {
  data?: API_SharedAttachments["items"];
  // removeFiles: (fileIds: number[]) => Promise<void>;
  addFiles: (fileIds: API_FileAttachment[]) => Promise<void>;
  fileType?: string;
  allowedFileTypes?: string[];
  isRadioSelection?: boolean;
}
type attachSection = "NAV" | "SEARCH";

interface AttachProjectFilesState {
  renderSection: attachSection; // enums that represent showing of certain section
}

export const AttachProjectFiles = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<AttachProjectFilesProps, AttachProjectFilesState> {
      constructor(props: AttachProjectFilesProps) {
        super(props);

        this.state = {
          renderSection: "NAV",
        };
      }

      toggleSection = () => {
        const renderSection = this.state.renderSection === "NAV" ? "SEARCH" : "NAV";
        this.setState({ renderSection });
      };

      handleAddAttachments = async (data) => {
        if (!data.length) {
          message.error(this.props.t("No files selected"));
        } else {
          await this.props.addFiles(data).then(() => {
            this.props.hideModal();
          });
        }
      };

      render() {
        const { data, addFiles, hideModal } = this.props;
        if (this.state.renderSection === "NAV") {
          return (
            <ProjectDocumentsTable
              handleAddAttachments={this.handleAddAttachments}
              onShowSearch={this.toggleSection}
              onExit={this.props.hideModal}
              minimumAccessLevel="READONLY"
              fileType={this.props.fileType}
              allowedFileTypes={this.props.allowedFileTypes}
              isRadioSelection={this.props.isRadioSelection}
              // initialValue={taskDataStore.fileList}
            />
          );
        } else if (this.state.renderSection === "SEARCH") {
          return (
            <ProjectFilesSearch
              data={data}
              fileType={this.props.fileType}
              allowedFileTypes={this.props.allowedFileTypes}
              addFiles={addFiles}
              onCancel={this.toggleSection}
              onExit={hideModal}
            />
          );
        } else {
          return null;
        }
      }
    }
  )
);
